export var EPropertyFetchType;
(function (EPropertyFetchType) {
    EPropertyFetchType["Owned"] = "OWNED";
    EPropertyFetchType["Rented"] = "RENTED";
    EPropertyFetchType["Groups"] = "GROUPS";
    EPropertyFetchType["InGroup"] = "IN_GROUP";
})(EPropertyFetchType || (EPropertyFetchType = {}));
